import { render } from "./LandingPage.vue?vue&type=template&id=1a83a65d&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=1a83a65d&lang=scss"
import "./LandingPage.vue?vue&type=style&index=1&id=1a83a65d&lang=scss&scoped=true"
import "./LandingPage.vue?vue&type=style&index=2&id=1a83a65d&lang=scss&scoped=true"

import exportComponent from "/Users/saschas/dev/neurocure_website/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a83a65d"]])

export default __exports__